import { api } from '@/shared/api/client';

export const searchApplicationByLuggageQr = async (qrCode: string) => {
    return api.get('/applications', {
        query: { qr_code: qrCode },
    });
};
